const resolveClient = async (clientSource) =>
  typeof clientSource === "function" ? clientSource() : clientSource;

export const createLessonOrderService = (clientSource) => ({
  async save(lessons = []) {
    if (lessons.length === 0) return [];

    const [{ course_id: courseId, delivery_mode: deliveryMode }] = lessons;
    const hasMixedScope = lessons.some(
      (lesson) =>
        lesson.course_id !== courseId || lesson.delivery_mode !== deliveryMode,
    );
    if (!courseId || !deliveryMode || hasMixedScope) {
      throw new Error("Lessons must belong to one course delivery mode");
    }

    const client = await resolveClient(clientSource);
    const { data, error } = await client.rpc("reorder_course_lessons", {
      p_course_id: courseId,
      p_delivery_mode: deliveryMode,
      p_lesson_ids: lessons.map((lesson) => lesson.id),
    });
    if (error) throw error;
    return data || [];
  },
});

export const lessonOrderService = createLessonOrderService(async () => {
  const { supabase } = await import("../lib/supabase.js");
  return supabase;
});
